export class GameBitMapFontStyle {
    constructor() { }
}
GameBitMapFontStyle.COUNTER = {
    fontName: "WPGoldDigger", align: "center", letterSpacing: -2.5
};
//# sourceMappingURL=GameBitMapFontStyle.js.map